
import React from 'react'
import ModalImage from "react-modal-image"
import PageHeading from '../components/PageHeading'
import { useEffect } from 'react';
import reference from '../img/reference.jpg';
import reference2 from '../img/reference2.jpg';
import reference3 from '../img/reference3.jpg';
import reference4 from '../img/reference4.jpg';
import reference5 from '../img/reference5.jpg';
import reference6 from '../img/reference6.jpg';
import ContactBanner from '../components/ContactBanner';
import '../css/References.css'

export default function References() {

  useEffect(() => {
    document.title = "Referenser";
      window.scrollTo(0,0);
  });

  return (
    <>
      <PageHeading title="Referenser" />
      <ContactBanner />
      <div className='px-lg-6 px-4 mb-3'>
        <div className='d-flex justify-content-between flex-column flex-sm-row gap mb-3'>
          <div className='reference-image'>
            <ModalImage
              small={reference}
              large={reference}
              alt="referensbild"
            />
          </div>
          <div className='reference-image'>
            <ModalImage
              small={reference2}
              large={reference2}
              alt="referensbild"
            />
          </div>
        </div>
        <div className='d-flex justify-content-between flex-column flex-sm-row gap mb-3'>
          <div className='reference-image'>
            <ModalImage
              small={reference3}
              large={reference3}
              alt="referensbild"
            />
          </div>
          <div className='reference-image'>
            <ModalImage
              small={reference4}
              large={reference4}
              alt="referensbild"
            />
          </div>
        </div>
        <div className='d-flex justify-content-between flex-column flex-sm-row gap'>
          <div className='reference-image'>
            <ModalImage
              small={reference5}
              large={reference5}
              alt="referensbild"
            />
          </div>
          <div className='reference-image'>
            <ModalImage
              small={reference6}
              large={reference6}
              alt="referensbild"
            />
          </div>
        </div>
      </div>
    </>
  )
}